// FILE: src/components/register/RegisterHeader.jsx
import React from "react";

export default function RegisterHeader() {
  return (
    <div style={{ textAlign: "center", marginBottom: 16 }}>
      <img src="/Lastwishbox-logo.png" alt="LastWish Box" style={{ height: 40, marginBottom: 8 }} />
      <div>
        <a href="/personal/plans"
           style={{ display:"inline-block", padding:"8px 12px", borderRadius:10, border:"1px solid #d6d6e7", textDecoration:"none", color:"#111827" }}>
          Select a Different Plan
        </a>
      </div>
    </div>
  );
}
